export default "__VITE_ASSET__5EB_K7ud__"